import { Component, Input, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TextFieldModule } from '@angular/cdk/text-field';

export interface SubTaskHeaderFieldsValue {
  name: string;
  description: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'lib-sub-task-header-fields',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TextFieldModule],
  templateUrl: './sub-task-header-fields.component.html',
  styleUrls: ['./sub-task-header-fields.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SubTaskHeaderFieldsComponent),
      multi: true
    }
  ]
})
export class SubTaskHeaderFieldsComponent implements ControlValueAccessor {
  @Input() showForm: boolean = false;
  @Input() isSubTask: boolean = false;
  @Input() isPreviewMode: boolean = false;
  @Input() isReadOnly: boolean = false;
  @Input() nameControl: FormControl | null = null;
  @Input() descriptionControl: FormControl | null = null;
  @Input() displayName: string = '';
  @Input() displayDescription: string = '';
  @Input() namePlaceholder: string = 'Please provide a unique title for this sub task *';
  @Input() descriptionPlaceholder: string = 'Provide instructions for this sub task *';
  @Input() nameMaxLength: number = 120;
  @Input() descriptionMaxRows: number | null = null;

  private onChange: (value: SubTaskHeaderFieldsValue) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: SubTaskHeaderFieldsValue): void {
    if (value) {
      this.displayName = value.name || '';
      this.displayDescription = value.description || '';
    }
  }

  registerOnChange(fn: (value: SubTaskHeaderFieldsValue) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Handle disabled state if needed
  }
}
